import {
  BooleanParam,
  DateTimeParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

/**
 * Prefixed with `legacy` so this block can live on the same page as the
 * non-legacy automation history block without sharing its cursors/filters.
 */
export const queryParams = {
  legacyAfter: StringParam,
  legacyBefore: StringParam,
  legacyFirst: withDefault(NumberParam, 20),
  legacyFrom: DateTimeParam,
  legacyLast: NumberParam,
  legacyShowSuspended: BooleanParam,
  legacyTo: DateTimeParam,
};
